import React, { useEffect, useState } from 'react';
import EDIT_ICON from 'assets/img/edit-01.svg';
import CHECKED_ICON from 'assets/img/checked2.svg';
import EditBigBox from './EditBigBox';
import { use } from 'react';
export default function EditableText({
  title,
  isEditor = false,
  handleSubmitTitle,
  hideEditButton,
  defaultEditMode,
  handleChangeTitle,
  backClicked = false,
  setBackClicked = () => {},
  handleCloseTitle = () => {},
  showCheckmark = false,
  handletoggleCompletetask = () => {},
  isCompletedMilestone = false,
  viewMode = false
}) {
  const [showEditMode, setShowEditMode] = useState(defaultEditMode || false);

  useEffect(() => {
    if (backClicked) {
      setShowEditMode(false);
      setBackClicked(false);
    }
  }, [backClicked]);

  const handleSubmit = (data) => {
    console.log(data);

    handleSubmitTitle(data);
    setShowEditMode(false);
  };
  return (
    <>
      {!showEditMode ? (
        <div className="editable-text-title d-flex align-items-start gap-2">
          {/* {showCheckmark && 
          
          <img src={CHECKED_ICON} alt="checked" className="checked-item" width={28} />
          
          
          } */}

          {/* {showCheckmark && ( */}
          {showCheckmark && (
            <label className="main-checkbox">
              <input
                type="checkbox"
                checked={isCompletedMilestone}
                onChange={handletoggleCompletetask} // 👈 toggle handler
              />
              <span className="checkmark"></span>
            </label>
          )}
          {/* )} */}

          <p className="heading mx-100 mb-0 pl-0" dangerouslySetInnerHTML={{ __html: title }}></p>
          {!hideEditButton && (
            <button className="btn-icon edit-icon-title" style={{display: "block"}}>
              <img src={EDIT_ICON} alt="edit" className="clickable-item" onClick={() => setShowEditMode(true)} />
            </button>
          )}
        </div>
      ) : (
        <EditBigBox
          isEditor={isEditor}
          onChange={handleChangeTitle}
          title={title}
          onClose={() => {
            handleCloseTitle();
            setShowEditMode(false);
          }}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}
